/**
 * Personstamm API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { FieldMetaData } from './fieldMetaData';
import { CodeEntryMeta } from './codeEntryMeta';
import { DateEntryMeta } from './dateEntryMeta';
import { PersonAdresseListEntryMeta } from './personAdresseListEntryMeta';


export interface PersonStammListEntryMeta { 
    art?: PersonStammListEntryMeta.ArtEnum;
    mArt?: FieldMetaData;
    vorname?: string;
    mVorname?: FieldMetaData;
    unternehmensId?: string;
    mUnternehmensId?: FieldMetaData;
    auskunftsperre?: PersonStammListEntryMeta.AuskunftsperreEnum;
    mAuskunftsperre?: FieldMetaData;
    anrede?: CodeEntryMeta;
    mAnrede?: FieldMetaData;
    geburtsdatum?: DateEntryMeta;
    mGeburtsdatum?: FieldMetaData;
    adressen?: Array<PersonAdresseListEntryMeta>;
    mAdressen?: FieldMetaData;
    isGueltig?: boolean;
    mIsGueltig?: FieldMetaData;
    fremdId?: string;
    mFremdId?: FieldMetaData;
    mitGrundbuchbezug?: boolean;
    mMitGrundbuchbezug?: FieldMetaData;
    name?: string;
    mName?: FieldMetaData;
    ahvNummer?: string;
    mAhvNummer?: FieldMetaData;
    bezeichnung?: string;
    mBezeichnung?: FieldMetaData;
}
export namespace PersonStammListEntryMeta {
    export type ArtEnum = 'ALLE_PERSON' | 'NATUERLICHE_PERSON' | 'JURISTISCHE_PERSON' | 'GEMEINSCHAFT' | 'OEFFENTLICH_RECHTLICHE_PERSON';
    export const ArtEnum = {
        ALLE_PERSON: 'ALLE_PERSON' as ArtEnum,
        NATUERLICHE_PERSON: 'NATUERLICHE_PERSON' as ArtEnum,
        JURISTISCHE_PERSON: 'JURISTISCHE_PERSON' as ArtEnum,
        GEMEINSCHAFT: 'GEMEINSCHAFT' as ArtEnum,
        OEFFENTLICH_RECHTLICHE_PERSON: 'OEFFENTLICH_RECHTLICHE_PERSON' as ArtEnum
    };
    export type AuskunftsperreEnum = 'AUSKUNFT_SPERRE' | 'ADRESS_SPERRE' | 'KEINE';
    export const AuskunftsperreEnum = {
        AUSKUNFT_SPERRE: 'AUSKUNFT_SPERRE' as AuskunftsperreEnum,
        ADRESS_SPERRE: 'ADRESS_SPERRE' as AuskunftsperreEnum,
        KEINE: 'KEINE' as AuskunftsperreEnum
    };
}


